import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import "./style.css";

const InsuranceServicesBox = () => {
  const history = useHistory();

  const [services, setServices] = useState([
    {
      name: "Insurance POSP",
      image: "/images/insurance-dekho-icon.png",
      href: "/user/insurance",
    },
  ]);

  const navigate = (path) => {
    history.push(path);
  };

  return (
    <React.Fragment>
      <div className="dash-serviceBoxTitle">Insurance</div>
      <div className="row pt-2">
        {services.map((value, key) => (
          <div className="col-sm-2">
            <div className="card">
              <div
                className="dash-serviceBox"
                onClick={() => {
                  navigate(value.href);
                }}
              >
                <div className="service-image">
                  <a href>
                    <img
                      className="img-thumbnail rounded-circle avatar-md"
                      alt="logo"
                      src={value.image}
                    />
                  </a>
                </div>
                <div className="service-content">
                  <h6 style={{ color: "black" }}>{value.name}</h6>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default InsuranceServicesBox;
